export type ListStatus = "thinking" | "building" | "waiting" | "ready" | null;

export const statusFilterOrder = [
  "thinking",
  "building",
  "waiting",
  "ready",
] as const;
export type StatusFilterValue = (typeof statusFilterOrder)[number];

export const statusFilterLabels: Record<StatusFilterValue, string> = {
  thinking: "3B is thinking",
  building: "3B is building",
  waiting: "3B needs you",
  ready: "Ready",
};

type BranchData = {
  respondingAt: number | null;
  lastChatEntryAt: number | null;
  lastChatEntryType: string | null;
  awaitingAction: boolean | null;
};

export function getBranchListStatus(
  branch: BranchData,
  lastSeenAt?: number
): ListStatus {
  if (!branch.lastChatEntryType) return null;

  const isResponding = branch.respondingAt != null;

  let status: ListStatus;
  switch (branch.lastChatEntryType) {
    case "UserMessage":
      status = isResponding ? "thinking" : null;
      break;
    case "AssistantReasoning":
      status = isResponding ? "thinking" : "ready";
      break;
    case "AssistantToolUse":
      if (branch.awaitingAction) {
        status = "waiting";
      } else if (isResponding) {
        status = "building";
      } else {
        status = "ready";
      }
      break;
    case "AssistantMessage":
      status = isResponding ? "thinking" : "ready";
      break;
    default:
      status = isResponding ? "thinking" : null;
  }

  if (
    status === "ready" &&
    lastSeenAt != null &&
    branch.lastChatEntryAt != null &&
    lastSeenAt >= branch.lastChatEntryAt
  ) {
    return null;
  }

  return status;
}
